import CheckmarkIcon from '@assets/icons/checkmark-thin.svg';
import MinusIcon from '@assets/icons/minus.svg';
import React from 'react';
import { Checkbox } from './checkbox';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, ViewStyle } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';

interface Props {
  disabled?: boolean;
  isPartiallySelected: boolean;
  isSelected: boolean;
  onSelect: () => void;
  size?: number;
  style?: StyleProp<ViewStyle>;
  trackingData: TrackingData | null;
}

const DEFAULT_CHECKBOX_SIZE = 24;

export const MultiStateCheckbox: React.FC<Props> = ({
  disabled,
  isPartiallySelected,
  isSelected,
  onSelect,
  size = DEFAULT_CHECKBOX_SIZE,
  style,
  trackingData,
}) => {
  const [styles, theme] = useStyles();
  const iconSize = Math.round(size * 0.75);

  return (
    <Checkbox
      disabled={disabled}
      getCheckboxStyle={(checked) => {
        return [
          styles.checkboxCheck,
          { height: size, width: size },
          checked ? styles.checkboxCheckSelected : null,
        ];
      }}
      icon={
        isPartiallySelected ? (
          <MinusIcon
            height={iconSize}
            stroke={theme.sk.color.icon.ondark}
            width={iconSize}
          />
        ) : (
          <CheckmarkIcon
            height={iconSize}
            stroke={theme.sk.color.icon.ondark}
            width={iconSize}
          />
        )
      }
      isSelected={isSelected}
      onSelect={onSelect}
      style={[styles.checkbox, style]}
      trackingData={trackingData}
    />
  );
};

const useStyles = createStyles((theme) => ({
  checkbox: {
    backgroundColor: 'transparent',
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  checkboxCheck: {
    borderWidth: 1,
  },
  checkboxCheckSelected: {
    backgroundColor: theme.sk.color.bg.checkbox.active,
    borderColor: theme.sk.color.bg.checkbox.active,
  },
}));
